import React, { useState } from 'react';
import DistrictServices from '../../services/DistrictServices';

const PincodeStatus = ({pincode,page ,onSuccess}) => {

const [isChecked, setIsChecked] = useState(pincode?.status === 'Active');

  const handleToggle = async () => {
    const newStatus = !isChecked ? 'Active' : 'Inactive';
    setIsChecked(!isChecked);
    if(page === 'Pincode'){
      const res = await DistrictServices.updatePincodeStatus(pincode._id, {
        status: newStatus
      });
      onSuccess();
    }
  };

  return (
   
      <div className="check-box">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
        />
      </div>
    
  );
};

export default PincodeStatus;
